import React from 'react';
import { Outlet } from 'react-router-dom';
import AppProviders from '@/components/layout/AppProviders';
import OfflineRedirect from '@/components/pwa/OfflineRedirect';
import ScrollToTop from '@/components/ui/ScrollToTop';
import LenisProvider from '@/components/layout/LenisProvider';
import Favicon from '@/components/layout/Favicon';
import PWAManifest from '@/components/pwa/PWAManifest';
import PWARegister from '@/components/pwa/PWARegister';
import PWAUpdater from '@/components/pwa/PWAUpdater';
import InstallPwaModal from '@/components/pwa/InstallPwaModal';
import ConditionalLoading from '@/components/ui/ConditionalLoading';

export default function RootLayout() {

    return (
        <AppProviders>
            <OfflineRedirect />
            <ScrollToTop />
            <LenisProvider />
            <Favicon />
            <PWAManifest />
            <PWARegister />

            <ConditionalLoading>
                <Outlet />
            </ConditionalLoading>

            <InstallPwaModal />
            <PWAUpdater />
        </AppProviders>
    );
}
